<template lang="html">
  <div class="">
    <Container
      lock-axis="y"
      group-name="fields"
      class="flex pa-0"
      :get-child-payload="i => {return lazyValue[i]}"
      @drop="onDropField"
    >
      <Draggable
        v-for="(fieldName, i) in lazyValue"
        :key="fieldName"
      >
        <v-flex>
          <v-card
            :color="field(fieldName).error ? 'error' : ''"
            :outlined="highlightField !== fieldName"
            :elevation="highlightField === fieldName ? 10 : undefined"
          >
            <v-container>
              <v-layout align-center>
                <v-icon class="cursor-move">
                  drag_indicator
                </v-icon>
                <v-flex
                  shrink
                  px-2
                >
                  <v-tooltip right>
                    <template #activator="{ on }">
                      <v-icon
                        v-if="field(fieldName).condition"
                        color="warning"
                        class="cursor-default"
                        v-on="on"
                      >
                        call_split
                      </v-icon>
                      <v-icon
                        v-else
                        class="cursor-default"
                      >
                        arrow_upward
                      </v-icon>
                    </template>
                    <SiConditionChips :condition="field(fieldName).condition" />
                  </v-tooltip>
                </v-flex>
                <v-flex shrink>
                  <div
                    v-if="field(fieldName).error"
                    class="font-weight-bold white--text"
                  >
                    Field does not exist. It may have been deleted.
                  </div>
                  <div class="font-weight-bold">
                    {{ field(fieldName).name }}
                  </div>
                  <div
                    class="caption grey--text text-wrap"
                    v-html="field(fieldName).label"
                  />
                </v-flex>

                <v-spacer />
                <v-tooltip
                  v-if="field(fieldName).inputType === 'multi_line'"
                  left
                >
                  <template #activator="{ on }">
                    <v-icon
                      class="ml-3"
                      color="blue"
                      v-on="on"
                    >
                      playlist_add
                    </v-icon>
                  </template>
                  <v-flex>Contains Fields </v-flex>
                  <v-flex
                    v-for="fieldItem in field(fieldName).fields"
                    :key="fieldItem.id"
                  >
                    <v-chip
                      :key="fieldItem.id"
                      small
                      square
                    >
                      {{ fieldItem }}
                    </v-chip>
                  </v-flex>
                </v-tooltip>
                <v-icon
                  v-if="isInMulti(fieldName)"
                  class="ml-3"
                  color="grey"
                >
                  playlist_play
                </v-icon>
                <v-icon
                  v-if="fieldAlreadyUsed(fieldName)"
                  color="warning"
                >
                  file_copy
                </v-icon>

                <SiDeleteButton
                  title="Remove field?"
                  :message="`Are you sure you want to remove field <strong>${fieldName}</strong>? If you remove this field it will no longer show on the form <br> <br> <strong> IMPORTANT: </strong> Ensure this field id is not used in code before removing.`"
                  delete-button-text="remove"
                  @delete="removeField(i)"
                >
                  <template #activator="{ on }">
                    <v-btn
                      text
                      small
                      icon
                      color="grey"
                      v-on="on"
                    >
                      <v-icon>close</v-icon>
                    </v-btn>
                  </template>
                </SiDeleteButton>
              </v-layout>
            </v-container>
          </v-card>
        </v-flex>
      </Draggable>
    </Container>
    <v-layout ma-0>
      <v-spacer />
      <v-flex shrink>
        <SiFieldPicker
          :fields="fields"
          :picked="pickedFields"
          @field="addField"
        >
          <template #activator>
            <v-btn
              text
              color="primary"
            >
              <v-icon left>
                add
              </v-icon>add
            </v-btn>
          </template>
        </SiFieldPicker>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { isArray, forEach, uniq, countBy, includes } from 'lodash'
import { Container, Draggable } from 'vue-smooth-dnd'

export default {
  components: { Container, Draggable },
  props: {
    fields: Object,
    allPickedFields: Array,
    value: Array,
    highlightField: String,
  },
  data () {
    return {
      lazyValue: this.value
    }
  },
  computed: {
    pickedFields () {
      return uniq(this.allPickedFields).concat(this.inMulti)
    },
    inMulti () {
      var inMulti = []
      forEach(this.fields, f => {
        inMulti = inMulti.concat(f.fields) || []
      })
      return inMulti.filter(x => {
        return x
      })
    }
  },
  watch: {
    value (v) {
      this.lazyValue = v
    }
  },
  methods: {
    isInMulti (fieldName) {
      return includes(this.inMulti, fieldName)
    },
    field (fieldName) {
      return this.fields[fieldName] || { error: true }
    },
    fieldAlreadyUsed (fieldName) {
      return countBy(this.allPickedFields)[fieldName] > 1
    },
    addField (fieldName) {
      if (!isArray(this.lazyValue)) this.lazyValue = []
      this.lazyValue.push(fieldName)
      this.$emit('input', this.lazyValue)
      this.$emit('change', this.lazyValue)
    },
    removeField (i) {
      this.lazyValue.splice(i, 1)
      this.$emit('input', this.lazyValue)
      this.$emit('change', this.lazyValue)
    },
    onDropField (e) {
      if (e.removedIndex === null && e.addedIndex === null) return // return because drop is fired for every group. Only run for ones that have a change

      if (!isArray(this.lazyValue)) this.lazyValue = []

      if (e.removedIndex !== null) {
        this.lazyValue.splice(e.removedIndex, 1)
      }
      if (e.addedIndex !== null) {
        this.lazyValue.splice(e.addedIndex, 0, e.payload)
      }
      this.$emit('input', this.lazyValue)
      this.$emit('change', this.lazyValue)
    }
  }
}
</script>

<style lang="css" scoped>
.smooth-dnd-draggable-wrapper{
  overflow: visible !important;
}
</style>
